import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[addHost]',
})
export class AddDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
